const processMatch = (match) => {
  if (!match) return match;
  match.model = match.model_name;
  delete match.model_name;
  return match;
};

export default processMatch;
